<div class="gse-upload" fxLayout="column">
    <div fxLayout="column" fxLayoutAlign="center center">
        <app-icon class="header-icon" name="fal-file-excel"></app-icon>
    </div>
    <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
        <div fxFlex app-input-container>
        <div class="mb-10">{{ "Please select a file type"|i18n }}</div>
            <mat-select app-small-select [placeholder]="'File type'|i18n"
                        [(ngModel)]="fileType">
                <mat-option *ngFor="let type of FILE_TYPES"
                            [value]="type">
                    {{ type|genericPipe }}
                </mat-option>
            </mat-select>
        </div>
        <div fxLayout="column" fxLayoutGap="20px">
            <div class="text-1">
                {{ 'Upload the file'|i18n }}
                <strong>{{ ' Corrispettivo_[anno]-[mese]_INCENTIVO_(...).xlsx '|i18n }}</strong>
                <span *ngIf="fileType">{{ 'of type '|i18n }}</span>
                <strong *ngIf="fileType">{{ (fileType|genericPipe).toLowerCase() }}</strong>
                {{ 'provided by the GSE'|i18n }}
            </div>
            <div fxLayout="column" fxLayoutAlign="start center">
                <div>{{ "Please do not alter the structure or master data in the GSE file."|i18n }}</div>
                <div>{{ "Any changes may prevent it from being uploaded correctly."|i18n }}</div>
            </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="20px">
                <span class="txt-p-16-4">{{ 'Upload the file'|i18n }}{{ ":" }}</span>
                <input #fileSelect type="file" style="display: none"
                       [accept]="XLSX_MIME_TYPE"
                       (change)="onClickUploadTemplate($event)">
                <button app-primary-button
                        (click)="fileSelect.click()"
                        [disabled]="!fileType">
                    <app-icon [name]="templateChosen ? 'fal-sync' : 'fal-search'"></app-icon>
                    {{ (templateChosen ? 'Change file' : 'Select file')|i18n }}
                </button>
                <span *ngIf="this.template?.name" class="txt-p-16-4">{{ this.template?.name }}</span>
                <div *ngIf="!this.template.name"
                     class="txt-s-14-4">{{ 'No file uploaded'|i18n }}
                </div>
                <button *ngIf="templateChosen"
                        app-icon-button
                        class="app-button-alert"
                        (click)="onClickTrashTemplate(fileSelect)">
                    <app-icon name="fal-trash-alt"></app-icon>
                </button>
            </div>
            <span fxLayoutAlign="center center" class="txt-s-14-4">
                    {{ '(Max {0} MB. Accepts only XLSX files.)'|i18n:MAX_FILE_MB }}
                </span>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-evenly" class="mt-42">
        <button app-ghost-button type="button"
                [mat-dialog-close]="false">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-times"></app-icon>
                <span>{{ 'Cancel'|i18n }}</span>
            </div>
        </button>
        <button app-primary-button type="button"
                (click)="sendIt()"
                [disabled]="!this.templateChosen">
            <app-icon name="fal-check-circle"></app-icon>
            {{ 'Save Data'|i18n }}
        </button>
    </div>
</div>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>

<ng-template #gseErrors let-data let-close="close">
    <app-gse-errors [gseResponse]="data.gseResponse"></app-gse-errors>
    <div fxLayout="row" fxLayoutAlign="center center" app-dialog-actions>
        <button app-primary-button (click)="close(true)">
            {{ 'Ok'|i18n }}
        </button>
    </div>
</ng-template>
